import { createSelector } from 'reselect';
import strToRegExp, { isValidRegExpStr } from '../utils/strToRegExp';
const getNavItems = state => state.navItems;
export const selectNavItemsById = state => state.navItems.byId;
export const selectNavItemsByPath = state => state.navItems.byPath;
export const selectHasGlobalHomeAccess = createSelector([getNavItems], navItems => !!navItems.byId['global-home']);
const getPathname = (_, {
  pathname
}) => pathname;

/**
 * Parametric selector to find the matching nav item path for a given pathname
 */
export const selectMatchingNavItemPath = createSelector([selectNavItemsByPath, getPathname], (navItemsByPath, pathname) => {
  const navItemPaths = Object.keys(navItemsByPath);
  return navItemPaths.find(navItemPath => {
    let regExp = strToRegExp(navItemPath);
    if (!isValidRegExpStr(navItemPath)) {
      regExp = strToRegExp(`/^\\${navItemPath}(\\/.*)?$/i`);
    }
    return regExp ? regExp.test(pathname) : false;
  });
});